import filterList from '@shared/lib/general/filterList';

const filterAlertsData = (data, systemFilter) => {
  let newAlertFilteredData = data;
  if (systemFilter.thermostatZone.length) {
    const filteredThermostatData = [];
    let newAlertTableData = [];

    systemFilter.thermostatZone.forEach((sf) => {
      newAlertTableData = filterList(sf.uId, newAlertFilteredData, 'uid');
      filteredThermostatData.push(newAlertTableData);
    });
    newAlertFilteredData = filteredThermostatData.flat();
  }

  if (systemFilter.alertCategoryFilter.length) {
    let newCategoryData;
    const filteredCategoryData = [];

    systemFilter.alertCategoryFilter.forEach((ct) => {
      newCategoryData = filterList(ct, newAlertFilteredData, 'alertCategory');
      filteredCategoryData.push(newCategoryData);
    });
    newAlertFilteredData = filteredCategoryData.flat();
  }

  return newAlertFilteredData;
};

export default filterAlertsData;
